"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProductBoxData = void 0;
var _productBox = require("@ori/product-box");
var _staticApiClientReact = require("@ori/static-api-client-react");
/* istanbul ignore file */ const getProductBoxData = async (param)=>{
    let { productCode, tenant, staticApiUrl, language } = param;
    var _data_data;
    const staticApiClient = new _staticApiClientReact.ApiClient({
        baseUrl: staticApiUrl,
        language,
        tenant
    });
    const { data } = await (0, _staticApiClientReact.getTenantApplicationsProductBox)(staticApiClient, tenant, {
        lang: language,
        productCodes: [
            productCode
        ]
    });
    const products = ((_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.products) ? (0, _productBox.mapProductBoxesFromStaticApi)({
        data: data.data.products
    }) : null;
    return (products === null || products === void 0 ? void 0 : products.length) === 1 ? products[0] : null;
};
exports.getProductBoxData = getProductBoxData;
